<template>
    <section class="dp-layout theme-meeting-record-page">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <template v-if="schoolId > 0">
                <div class="filter-bar">
                    <el-form :inline="true" size="small" class="filter-form">
                        <el-form-item label="年月">
                            <el-date-picker
                                v-model="filterForm.yearMonth"
                                type="month"
                                placeholder="全部"
                                value-format="yyyy-MM"
                                clearable
                                style="width: 140px;"
                                @change="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item label="校区">
                            <el-select v-model="filterForm.campusId" placeholder="请选择校区" clearable style="width: 140px;" @change="handleSearch">
                                <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="filterForm.status" placeholder="全部" clearable style="width: 120px;" @change="handleSearch">
                                <el-option label="已提交" :value="0" />
                                <el-option label="已作废" :value="1" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关键字">
                            <el-input
                                v-model="filterForm.keyword"
                                placeholder="班级/教师"
                                clearable
                                style="width: 160px;"
                                @keyup.enter.native="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                            <el-button
                                v-if="hasActionPermission('handleExport')"
                                type="success"
                                icon="el-icon-download"
                                :loading="exporting"
                                @click="handleExport"
                            >导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="tbl-scroll-host">
                    <el-table :data="tableData" v-loading="loading" border height="100%" style="width: 100%;" class="compact-table">
                        <el-table-column type="index" label="#" width="50" align="center" />
                        <el-table-column prop="YearMonth" label="年月" width="90" align="center" />
                        <el-table-column prop="CampusName" label="校区" min-width="110" show-overflow-tooltip />
                        <el-table-column prop="ClassName" label="班级" min-width="120" show-overflow-tooltip />
                        <el-table-column prop="TeacherName" label="提交教师" min-width="100" show-overflow-tooltip />
                        <el-table-column label="现场照片" width="110" align="center">
                            <template slot-scope="scope">
                                <oss-el-image
                                    v-if="scope.row.ScenePhotos && scope.row.ScenePhotos.length"
                                    :src="scope.row.ScenePhotos[0]"
                                    :preview-src-list="scope.row.ScenePhotos"
                                    :school-id="schoolId"
                                    fit="cover"
                                    class="thumb"
                                />
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="方案照片" width="110" align="center">
                            <template slot-scope="scope">
                                <oss-el-image
                                    v-if="scope.row.PlanPhotos && scope.row.PlanPhotos.length"
                                    :src="scope.row.PlanPhotos[0]"
                                    :preview-src-list="scope.row.PlanPhotos"
                                    :school-id="schoolId"
                                    fit="cover"
                                    class="thumb"
                                />
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="加分" width="90" align="center">
                            <template slot-scope="scope">+{{ formatScore(scope.row.Score) }}</template>
                        </el-table-column>
                        <el-table-column label="加分状态" min-width="140" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-tag :type="dutyScoreTagType(scope.row.DutyScoreStatus)" size="mini">
                                    {{ dutyScoreText(scope.row) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.Status === 1 ? 'info' : 'success'" size="mini">
                                    {{ scope.row.Status === 1 ? '已作废' : '已提交' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="提交时间" width="160" align="center">
                            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.Status !== 1 && hasActionPermission('openVoidDialog')"
                                    type="danger"
                                    size="mini"
                                    plain
                                    @click="openVoidDialog(scope.row)"
                                >作废</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pager">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next"
                        :total="total"
                        :current-page.sync="page"
                        :page-size.sync="pageSize"
                        :page-sizes="[10, 20, 50, 100]"
                        @current-change="loadTableData"
                        @size-change="handleSizeChange"
                    />
                </div>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择所属学校，查看主题班会记录</p>
                </div>
            </div>
        </section>

        <el-dialog title="作废记录" :visible.sync="voidVisible" width="420px" :close-on-click-modal="false">
            <el-form size="small" label-width="80px">
                <el-form-item label="班级">
                    <span>{{ voidRow && voidRow.ClassName }}</span>
                </el-form-item>
                <el-form-item label="年月">
                    <span>{{ voidRow && voidRow.YearMonth }}</span>
                </el-form-item>
                <el-form-item label="原因">
                    <el-input v-model="voidReason" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="可选" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="voidVisible = false">取消</el-button>
                <el-button type="danger" size="small" :loading="voiding" @click="confirmVoid">确认作废</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getButtonList } from '../../promissionRouter';
import { getCampusList } from '../../api/modules/misc';
import {
    getThemeClassMeetingRecords,
    exportThemeClassMeetingRecords,
    voidThemeClassMeetingRecord
} from '../../api/modules/themeClassMeeting';
import { normalizeDeptId, deptIdsEqual, resolveActiveSchoolId } from '../../utils/deptCascaderProps';

export default {
    name: 'ThemeClassMeetingRecord',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            boundSchoolId: 0,
            buttonList: [],
            loading: false,
            exporting: false,
            voiding: false,
            tableData: [],
            campusOptions: [],
            page: 1,
            pageSize: 10,
            total: 0,
            filterForm: {
                yearMonth: '',
                campusId: null,
                status: 0,
                keyword: ''
            },
            voidVisible: false,
            voidRow: null,
            voidReason: ''
        };
    },
    created() {
        this.buttonList = getButtonList(this.$route.path) || [];
        const sid = this.resolveSchoolId();
        if (sid) this.applySchoolChange(sid, this.$store.state.activeSchoolName);
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            this.applySchoolChange(newSchoolId, this.$store.state.activeSchoolName);
        }
    },
    methods: {
        hasActionPermission(func) {
            if (!this.buttonList || !this.buttonList.length) return true;
            return this.buttonList.some(button => button.Func === func);
        },

        /** 解析当前学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            const local = normalizeDeptId(this.schoolId);
            if (local) return local;
            return '';
        },

        async applySchoolChange(schoolId, schoolName) {
            const id = normalizeDeptId(schoolId);
            if (!id) return;
            if (deptIdsEqual(id, this.schoolId) && deptIdsEqual(this.boundSchoolId, id)) return;
            this.schoolId = id;
            this.boundSchoolId = id;
            if (schoolName) this.schoolName = schoolName;
            this.page = 1;
            await this.loadCampusOptions(true);
            this.loadTableData();
        },

        treeNodeClick(data) {
            this.applySchoolChange(data && data.value, data && data.label);
        },

        /** 取校区列表第一项 Id，无校区返回 null */
        pickDefaultCampusId() {
            const first = (this.campusOptions || [])[0];
            if (!first) return null;
            const id = first.Id != null ? first.Id : first.id;
            return id != null ? id : null;
        },

        formatScore(v) {
            const n = Number(v);
            if (Number.isNaN(n)) return '-';
            return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
        },

        formatDateTime(v) {
            if (!v) return '-';
            const d = new Date(v);
            if (Number.isNaN(d.getTime())) return String(v).replace('T', ' ').slice(0, 19);
            const pad = n => (n < 10 ? '0' + n : '' + n);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },

        dutyScoreText(row) {
            if (row.DutyScoreStatus === 0) return '已加分';
            if (row.DutyScoreStatus === 1) return row.DutyScoreMessage || '待补分';
            if (row.DutyScoreStatus === 2) return '已回滚';
            return '-';
        },

        dutyScoreTagType(status) {
            if (status === 0) return 'success';
            if (status === 1) return 'warning';
            return 'info';
        },

        /**
         * 加载校区并默认选中第一个。创建于 2026-09-13
         * @param {boolean} forceDefault 是否强制覆盖当前选中校区
         */
        async loadCampusOptions(forceDefault = false) {
            if (!this.schoolId) return;
            try {
                const res = await getCampusList({ page: 1, intPageSize: 999, departmentId: this.schoolId });
                if (res.data && res.data.success) {
                    this.campusOptions = (res.data.response && res.data.response.data) || [];
                } else {
                    this.campusOptions = [];
                }
            } catch (e) {
                this.campusOptions = [];
            }
            const exists = this.campusOptions.some(c => String(c.Id != null ? c.Id : c.id) === String(this.filterForm.campusId));
            if (forceDefault || this.filterForm.campusId == null || !exists) {
                this.filterForm.campusId = this.pickDefaultCampusId();
            }
        },

        async loadTableData() {
            if (!this.schoolId) return;
            this.loading = true;
            try {
                const params = {
                    page: this.page,
                    intPageSize: this.pageSize,
                    schoolId: this.schoolId,
                    yearMonth: this.filterForm.yearMonth || undefined,
                    campusId: this.filterForm.campusId || undefined,
                    status: this.filterForm.status === null || this.filterForm.status === '' ? undefined : this.filterForm.status,
                    keyword: this.filterForm.keyword || undefined
                };
                const res = await getThemeClassMeetingRecords(params);
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.tableData = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.tableData = [];
                    this.total = 0;
                    this.$message.error((res.data && res.data.msg) || '加载失败');
                }
            } catch (e) {
                this.tableData = [];
                this.total = 0;
                this.$message.error('加载失败');
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.page = 1;
            this.loadTableData();
        },

        async handleReset() {
            this.filterForm = { yearMonth: '', campusId: null, status: 0, keyword: '' };
            this.page = 1;
            await this.loadCampusOptions(true);
            this.loadTableData();
        },

        handleSizeChange() {
            this.page = 1;
            this.loadTableData();
        },

        /** 从 Blob 错误响应中读取后端提示 */
        readBlobMessage(blob) {
            return new Promise(resolve => {
                if (!blob) {
                    resolve('');
                    return;
                }
                const reader = new FileReader();
                reader.onload = () => {
                    const text = String(reader.result || '');
                    try {
                        const result = JSON.parse(text);
                        resolve(result.msg || result.message || text);
                    } catch (e) {
                        resolve(text);
                    }
                };
                reader.onerror = () => resolve('');
                reader.readAsText(blob);
            });
        },

        /** 按当前筛选导出 Excel。创建于 2026-09-25 */
        async handleExport() {
            if (!this.schoolId) return;
            if (!this.total || this.total <= 0) {
                this.$message.warning('没有数据可导出');
                return;
            }
            this.exporting = true;
            try {
                const params = {
                    schoolId: this.schoolId,
                    yearMonth: this.filterForm.yearMonth || undefined,
                    campusId: this.filterForm.campusId || undefined,
                    status: this.filterForm.status === null || this.filterForm.status === '' ? undefined : this.filterForm.status,
                    keyword: this.filterForm.keyword || undefined
                };
                const response = await exportThemeClassMeetingRecords(params);
                if (!response.data) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const contentType = String((response.headers &&
                    (response.headers['content-type'] || response.headers['Content-Type'])) || '').toLowerCase();
                const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType });
                if (!contentType.includes('spreadsheetml') && !contentType.includes('application/octet-stream')) {
                    const message = await this.readBlobMessage(blob);
                    this.$message.error(message || '导出失败');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `主题班会记录_${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (err) {
                if (!err || !err.bizMessage) {
                    this.$message.error('导出失败');
                }
            } finally {
                this.exporting = false;
            }
        },

        openVoidDialog(row) {
            this.voidRow = row;
            this.voidReason = '';
            this.voidVisible = true;
        },

        async confirmVoid() {
            if (!this.voidRow) return;
            this.voiding = true;
            try {
                const res = await voidThemeClassMeetingRecord({
                    id: this.voidRow.Id,
                    schoolId: this.schoolId,
                    reason: this.voidReason
                });
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '作废成功');
                    this.voidVisible = false;
                    this.loadTableData();
                } else {
                    this.$message.error((res.data && res.data.msg) || '作废失败');
                }
            } catch (e) {
                this.$message.error('作废失败');
            } finally {
                this.voiding = false;
            }
        }
    }
};
</script>

<style scoped>
.theme-meeting-record-page .filter-bar {
    margin-bottom: 10px;
    flex: 0 0 auto;
}
.theme-meeting-record-page .thumb {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    overflow: hidden;
}
.theme-meeting-record-page .pager {
    margin-top: 12px;
    text-align: right;
    flex: 0 0 auto;
}
.theme-meeting-record-page .muted {
    color: #C0C4CC;
}
.theme-meeting-record-page .compact-table:not(.el-table--scrollable-y) ::v-deep .el-table__body-wrapper {
    overflow-y: hidden !important;
}
.no-department-tip {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.no-department-tip__inner {
    text-align: center;
    color: #909399;
}
.no-department-tip__inner i {
    font-size: 40px;
    margin-bottom: 12px;
}
</style>
